<a [href]="pubA?.link" target="_blank">
  <!--<img *ngIf="!pubA?.imageName" src="assets/img/logo/pub1.png" width="100%" alt="" title="pub A" />-->
  <img  *ngIf="pubA?.imageName" [src]="publiciteImageUri + pubA?.imageName" width="100%" alt="pub A" [title]="pubA?.titre" />
</a>
